import { render, staticRenderFns } from "./PaymentDocumentList.vue?vue&type=template&id=6eb1804e&scoped=true&"
import script from "./PaymentDocumentList.vue?vue&type=script&lang=js&"
export * from "./PaymentDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb1804e",
  null
  
)

export default component.exports